import { Box, Text, VStack } from '@skin-seoul/design-system';

export const Spinner = () => (
  <VStack align="center" justify="center" w="full" h="240px">
    <Box
      border="4px solid #f3f3f3"
      borderTop="4px solid #3d1690"
      borderRadius="50%"
      w="40px"
      h="40px"
      animation="spin 1s linear infinite"
    />
    <Text mt="16px" style={{ fontSize: '16px' }} color="#3d1690" fontFamily="Plus Jakarta Sans, sans-serif">
      Loading...
    </Text>
  </VStack>
);
